const CloseIcon = ({
  height = "16px",
  width = "16px",
}: {
  height?: string;
  width?: string;
  onClick?: () => void;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="icon-close"
  >
    <path
      d="M1 1L15 15M15 1L1 15"
      stroke="#373738"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default CloseIcon;
